module.exports = __webpack_public_path__ + "img/Butterfly_00161.5eb62698.png";